export const sellerAgreementContent = {
  modalTitle: "Seller Terms & Conditions",
  documentTitle:
    "ELUMIA PHARMACEUTICAL PRODUCTS TRADING LLC SELLER TERMS & CONDITIONS",
  intro:
    'Welcome to Elumia MedStore. These Seller Terms & Conditions ("Terms") govern the use of the Elumia MedStore Seller Portal and the sale of products through the Elumia MedStore platform. By creating a Seller account, accessing the Seller Portal, listing products, accepting orders, or otherwise using the Platform, you agree to be legally bound by these Terms and Conditions.',
  sections: [
    {
      title: "1. ABOUT ELUMIA MEDSTORE",
      blocks: [
        {
          type: "paragraph",
          text: 'Elumia Pharmaceutical Products Trading LLC ("Elumia MedStore", "Company", "we", "our", or "us") operates an online platform that enables approved sellers to list, promote, and sell products to customers within the United Arab Emirates.',
        },
      ],
    },
    {
      title: "2. SELLER ELIGIBILITY",
      blocks: [
        {
          type: "paragraph",
          text: "To register as a Seller, you must:",
        },
        {
          type: "list",
          items: [
            "Hold a valid trade license and any applicable regulatory approvals.",
            "Be legally authorized to sell the products listed.",
            "Provide complete and accurate business information.",
            "Maintain updated contact and banking details.",
          ],
        },
        {
          type: "paragraph",
          text: "Elumia MedStore reserves the right to approve, reject, suspend, or terminate any Seller account at its sole discretion.",
        },
      ],
    },
    {
      title: "3. SELLER ACCOUNT RESPONSIBILITIES",
      blocks: [
        {
          type: "paragraph",
          text: "The Seller is responsible for:",
        },
        {
          type: "list",
          items: [
            "Maintaining account security.",
            "Protecting login credentials.",
            "Ensuring all information submitted is accurate.",
            "Updating company information whenever changes occur.",
          ],
        },
        {
          type: "paragraph",
          text: "The Seller shall be responsible for all activities conducted through its account.",
        },
      ],
    },
    {
      title: "4. PRODUCT LISTINGS",
      blocks: [
        {
          type: "paragraph",
          text: "The Seller may upload and list products through the Seller Portal.",
        },
        {
          type: "paragraph",
          text: "All product information including:",
        },
        {
          type: "list",
          items: [
            "Product names",
            "Descriptions",
            "Images",
            "Specifications",
            "Certifications",
            "Pricing",
          ],
        },
        {
          type: "paragraph",
          text: "must be accurate, complete, and current.",
        },
        {
          type: "paragraph",
          text: "Elumia MedStore reserves the right to edit, reject, suspend, or remove any listing that violates these Terms or applicable regulations.",
        },
      ],
    },
    {
      title: "5. PRODUCT QUALITY AND COMPLIANCE",
      blocks: [
        {
          type: "paragraph",
          text: "The Seller guarantees that all products:",
        },
        {
          type: "list",
          items: [
            "Are authentic and genuine.",
            "Are legally permitted for sale within the UAE.",
            "Are not expired.",
            "Maintain adequate shelf life.",
            "Comply with all applicable laws and regulations.",
          ],
        },
        {
          type: "paragraph",
          text: "The Seller shall be solely responsible for:",
        },
        {
          type: "list",
          items: [
            "Product quality.",
            "Product safety.",
            "Product warranties.",
            "Product recalls.",
            "Regulatory compliance.",
          ],
        },
      ],
    },
    {
      title: "6. INVENTORY MANAGEMENT",
      blocks: [
        {
          type: "paragraph",
          text: "The Seller shall maintain accurate inventory levels at all times. Products that are unavailable must not be listed as available. Repeated stock shortages may result in reduced visibility, penalties, suspension, or account termination.",
        },
      ],
    },
    {
      title: "7. PRICING POLICY",
      blocks: [
        {
          type: "paragraph",
          text: "The Seller shall maintain fair and competitive pricing. Prices listed on Elumia MedStore should be equal to or better than prices offered through other sales channels where reasonably applicable. Elumia MedStore reserves the right to request pricing reviews where necessary to maintain competitiveness and customer confidence.",
        },
      ],
    },
    {
      title: "8. COMMISSION AND PAYMENTS",
      blocks: [
        {
          type: "paragraph",
          text: "Elumia MedStore shall retain a commission percentage as agreed between the parties or as specified within the Seller Portal.",
        },
        {
          type: "paragraph",
          text: "Payments due to the Seller shall be released according to the payment schedule published by Elumia MedStore.",
        },
        {
          type: "paragraph",
          text: "The Company may deduct:",
        },
        {
          type: "list",
          items: [
            "Returns and refunds.",
            "Delivery charges.",
            "Payment processing fees.",
            "Regulatory penalties.",
            "Other agreed service charges.",
          ],
        },
      ],
    },
    {
      title: "9. ORDER FULFILLMENT",
      blocks: [
        {
          type: "paragraph",
          text: "The Seller is responsible for:",
        },
        {
          type: "list",
          items: [
            "Order processing.",
            "Product packaging.",
            "Product dispatch.",
            "Delivery readiness.",
          ],
        },
        {
          type: "paragraph",
          text: "Failure to fulfill orders within agreed timelines may result in penalties, reduced visibility, suspension, or termination.",
        },
      ],
    },
    {
      title: "10. RETURNS AND REFUNDS",
      blocks: [
        {
          type: "paragraph",
          text: "The Seller shall accept returns and refund requests for:",
        },
        {
          type: "list",
          items: [
            "Defective products.",
            "Damaged products.",
            "Incorrect products supplied.",
          ],
        },
        {
          type: "paragraph",
          text: "The Seller shall bear associated costs where responsibility lies with the Seller.",
        },
      ],
    },
    {
      title: "11. INTELLECTUAL PROPERTY",
      blocks: [
        {
          type: "paragraph",
          text: "The Seller grants Elumia MedStore a non-exclusive, royalty-free license to use product information, descriptions, images, trademarks, and marketing content for platform operations, promotions, advertising, and sales activities.",
        },
        {
          type: "paragraph",
          text: "The Seller warrants that all uploaded content does not infringe any third-party rights.",
        },
      ],
    },
    {
      title: "12. DATA PROTECTION AND CONFIDENTIALITY",
      blocks: [
        {
          type: "paragraph",
          text: "The Seller shall:",
        },
        {
          type: "list",
          items: [
            "Protect customer information.",
            "Maintain confidentiality of all business information.",
            "Use customer information solely for order fulfillment and customer service purposes.",
          ],
        },
        {
          type: "paragraph",
          text: "The Seller shall comply with all applicable UAE data protection laws.",
        },
      ],
    },
    {
      title: "13. PROHIBITED ACTIVITIES",
      blocks: [
        {
          type: "paragraph",
          text: "The Seller shall not:",
        },
        {
          type: "list",
          items: [
            "Upload false or misleading information.",
            "Sell counterfeit products.",
            "Sell prohibited or unauthorized products.",
            "Misuse customer information.",
            "Engage in fraudulent activity.",
            "Circumvent transactions conducted through Elumia MedStore.",
          ],
        },
      ],
    },
    {
      title: "14. SUSPENSION AND TERMINATION",
      blocks: [
        {
          type: "paragraph",
          text: "Elumia MedStore may suspend or terminate a Seller account immediately for:",
        },
        {
          type: "list",
          items: [
            "Regulatory violations.",
            "Fraudulent activity.",
            "Repeated customer complaints.",
            "Product non-compliance.",
            "Breach of these Terms.",
          ],
        },
      ],
    },
    {
      title: "15. LIMITATION OF LIABILITY",
      blocks: [
        {
          type: "paragraph",
          text: "Elumia MedStore shall not be liable for:",
        },
        {
          type: "list",
          items: [
            "Product defects.",
            "Seller operational failures.",
            "Regulatory non-compliance by the Seller.",
            "Customer claims arising from Seller-supplied products.",
          ],
        },
        {
          type: "paragraph",
          text: "The Seller agrees to indemnify and hold Elumia MedStore harmless against all claims, damages, penalties, costs, and liabilities arising from the Seller's products or activities.",
        },
      ],
    },
    {
      title: "16. AMENDMENTS",
      blocks: [
        {
          type: "paragraph",
          text: "Elumia MedStore reserves the right to amend these Terms at any time. Updated versions shall become effective immediately upon publication on the Platform. Continued use of the Platform constitutes acceptance of the revised Terms.",
        },
      ],
    },
    {
      title: "17. GOVERNING LAW",
      blocks: [
        {
          type: "paragraph",
          text: "These Terms shall be governed by and interpreted in accordance with the laws of the United Arab Emirates. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts of Dubai, United Arab Emirates.",
        },
      ],
    },
    {
      title: "18. ELECTRONIC ACCEPTANCE",
      blocks: [
        {
          type: "paragraph",
          text: 'By selecting "I Agree", "Confirm & Continue", "Accept", or any similar acceptance mechanism provided through the Seller Portal, the Seller acknowledges and agrees that:',
        },
        {
          type: "list",
          items: [
            "The Seller has read and understood these Terms and Conditions.",
            "The Seller agrees to be legally bound by these Terms and Conditions.",
            "Electronic acceptance shall have the same legal effect as a handwritten signature.",
            "The acceptance shall be recorded and maintained by Elumia MedStore as proof of agreement.",
          ],
        },
      ],
    },
  ],
  contact: {
    title: "CONTACT INFORMATION",
    blocks: [
      {
        type: "paragraph",
        text: "Elumia Pharmaceutical Products Trading LLC",
      },
      {
        type: "paragraph",
        text: "Warehouse No. 10, Abdouli Complex",
      },
      {
        type: "paragraph",
        text: "Al Qusais Industrial Area First",
      },
      {
        type: "paragraph",
        text: "Dubai, United Arab Emirates",
      },
      {
        type: "paragraph",
        text: "Phone: +971 50 257 6257",
      },
      {
        type: "link",
        prefix: "Email: ",
        text: "info@elumiamedstore.com",
        href: "mailto:info@elumiamedstore.com",
      },
      {
        type: "link",
        prefix: "Website: ",
        text: "www.elumiamedstore.com",
        href: "http://www.elumiamedstore.com",
      },
    ],
  },
};
